<template>
<!--
  Where is this used?: http://localhost:8080/submit-vectraits
  Purpose: This is really just to clean up the code on the /pages/vectraits/SubmitVectraitsData.vue component.
-->
    <div style="display: inline;">
        <b-button v-b-toggle.collapse-instructions variant="primary">Instructions</b-button>
        <b-collapse id="collapse-instructions">
        <div style="padding:15px;">
            <p><b>Submitting Data</b></p>
            <ol type="1">
            <li>
                Download template in CSV format by clicking the "Download" button.<br>
            </li>
            <li>
                You can refer to the 
                <router-link :to="{ name: 'vectraits-columndefs', params: { } }">
                    <u>field definitions section</u>
                </router-link>
                to guide you through the data collection and compilation process.
            </li>
            <li>
                To submit your data, upload your completed file by clicking "Browse" on the form below and then 
                click "Upload". 
            </li>
            <li>
                In order to submit data to VecTraits it must first pass validation to check that it is canonical 
                (as defined by the entries in the
                <router-link :to="{ name: 'vectraits-columndefs', params: { } }">
                    <u>field definitions section</u>
                </router-link> ). If there are problems with the file or data, you will see 
                a detailed summary and be given a chance to correct the errors and upload an amended file.
            </li>
            <li>
                Once the data passes validation, you will see a summary of the data objects about to be created. 
                This is to give you a chance to review the operations that are about to be done on the database.
            </li>
            <li>
                Click the green "Confirm" button to complete the process and write the new data to the database or 
                click "Cancel" to abort.
            </li>
            </ol>

            <b>Note that the following fields are required and must be filled in for each row:</b><br>
            <ul>
                <li v-for="(definition, index) in reqd_cols" :key="index" :title="definition.definition">{{ definition.field_name }}</li>
            </ul>

            <b>A note about date formats:</b><br>
            <p>The desired date format is YYYY-MM-DD. The system <i>can</i> handle Excel style dates (1/1/00) but 
            some extra care must be taken to prevent errors. If only two digits are provided for the year the 
            system will attempt to guess the century by applying the digits to a date in the next or last 50 years.
            For example, if "81" is provided in the data, the system will assign 1981 while "49" will be assigned 
            2049.</p>
            
            <p>Additionally, there could be errors due to ambiguity based on localization. 5/2/2021 could refer to 
            the 5th of February or the 2nd of May depending on where you are. The only way to guarantee that your 
            dates will be what you expect them to be is to use the YYYY-MM-DD format.</p>

        </div>
        </b-collapse>
    </div>
</template>
<script>
import { HTTP } from "@/utilities/http-common";

export default{
    name: "submit-instructions",
    data() {
        return {
            reqd_cols: [],
        }
    },
    created() {
        this.getColumnDefinitionData();
    },
    methods: {
        /**
         * Grab the column definitions from the API and narrow down to only required vectraits fields
         */
        getColumnDefinitionData() {
            HTTP.get(`/api/column-definitions/`)
            .then(response => {
                // only store vectraits definitions that are required.
                this.reqd_cols = response.data
                    .filter(definition => definition.database === "VECTRAITS" && definition.is_required === true)
                    .sort((a, b) => a.field_name.localeCompare(b.field_name));
            })
        }
    }
}
</script>
<style>
    .instructionsTable td {
        padding: 0 15px;
        vertical-align: top;
        font-size: smaller;
    }
</style>